import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { ContentState, convertToRaw, EditorState } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'
import type { FC } from 'react'
import React, { useState } from 'react'
import { Editor } from 'react-draft-wysiwyg'
import { Controller, useFormContext } from 'react-hook-form'

const defaultHtml = '<p></p>'

type Props = {
  fieldName: string
  fieldValue?: string
}

const FormHtmlEditor: FC<Record<string, unknown> & Props> = ({
  fieldName,
  fieldValue
}) => {
  const { control, setValue } = useFormContext()
  const html = fieldValue ?? defaultHtml
  const contentBlock = htmlToDraft(html)
  const contentState = ContentState.createFromBlockArray(
    contentBlock.contentBlocks
  )
  const [editorState, setEditorState] = useState(
    EditorState.createWithContent(contentState)
  )

  const onEditorStateChange = (updatedEditorState: EditorState) => {
    setEditorState(updatedEditorState)
    setValue(
      fieldName,
      draftToHtml(convertToRaw(editorState.getCurrentContent()))
    )
  }

  return (
    <>
      <Controller
        name={fieldName}
        control={control}
        defaultValue={fieldValue}
        as={
          <>
            <Editor
              editorState={editorState}
              wrapperClassName="wrapper-class"
              editorClassName="editor-class"
              toolbarClassName="toolbar-class"
              onEditorStateChange={onEditorStateChange}
              editorStyle={{
                marginTop: '20px',
                height: '500px',
                border: 'solid 0.5px rgba(0,0,0,0.3)',
                overflowY: 'auto'
              }}
            />
          </>
        }
      />
    </>
  )
}

export default FormHtmlEditor
